import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 font-bold text-lg no-underline mb-4"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-book-read-line"></i>
              </span>
              <span>{siteInfo.name}</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              {siteInfo.slogan}
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-background-50">
              分类浏览
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={cat.slug === "all" ? "/" : `/category/${cat.slug}`}
                  className="text-foreground-400 text-sm no-underline hover:text-background-50 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-background-50">
              热门推荐
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/article/1"
                className="text-foreground-400 text-sm no-underline hover:text-background-50 transition-colors"
              >
                我独自升级
              </Link>
              <Link
                to="/article/3"
                className="text-foreground-400 text-sm no-underline hover:text-background-50 transition-colors"
              >
                全知读者视角
              </Link>
              <Link
                to="/article/2"
                className="text-foreground-400 text-sm no-underline hover:text-background-50 transition-colors"
              >
                女神降临
              </Link>
              <Link
                to="/article/5"
                className="text-foreground-400 text-sm no-underline hover:text-background-50 transition-colors"
              >
                甜蜜的家庭
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-background-50">
              关于
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/about"
                className="text-foreground-400 text-sm no-underline hover:text-background-50 transition-colors"
              >
                关于我们
              </Link>
              <a
                href={`mailto:${siteInfo.email}`}
                className="text-foreground-400 text-sm no-underline hover:text-background-50 transition-colors"
              >
                联系邮箱
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 本站内容仅供推荐参考。
          </p>
          <p className="text-foreground-500 text-xs">
            好看的韩国漫画推荐 · 韩国漫画排行榜 · 韩国漫画大全
          </p>
        </div>
      </div>
    </footer>
  );
}